export default __webpack_public_path__ + "static/concrete-patio-removal-icon-ac372033c8353a05cf3e396662b62d15.png";